import {Injectable} from '@angular/core';
import {Scanner3dAccountModel} from '../../api/entity/scanner3dAccount.model';
import {AbstractFindOneByIdService} from '../../../../../core/service/v2/service/findone/abstractFindOneById.service';
import {Scanner3dAccountRepository} from './ngrx/scanner3dAccount.repository';
import {Scanner3dAccountDataServiceAdapter} from './ngrx/scanner3dAccountDataService.adapter';

@Injectable()
export class Scanner3dAccountFindOneByIdService extends AbstractFindOneByIdService<Scanner3dAccountModel, Scanner3dAccountModel> {

    constructor(repository: Scanner3dAccountRepository, dataServiceAdapter: Scanner3dAccountDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
